import createAction from 'Store/utils/createAction';
import { TRIP_INFORMATION_SET_DEPARTURE_CITY } from './constants';

function setDepartureCity({ value }: { value: string | null | undefined }): SetDepartureCityAction {
  return createAction(TRIP_INFORMATION_SET_DEPARTURE_CITY, {
    value,
  });
}

export { setDepartureCity };
